/**
 * Thin indeterminate bar shown while a route chunk downloads.
 *
 * This is the piece that stops the "did my click register?" problem. React
 * Router v7 navigates inside startTransition, which means React deliberately
 * keeps the current page on screen and shows no Suspense fallback while the
 * next chunk loads. Good — nothing flashes — but with no other signal the app
 * looks frozen, so people click again.
 */

import { useSyncExternalStore } from "react";
import { isNavPending, subscribeNavProgress } from "../../routes/navProgress";
import "./routeProgressBar.css";

const RouteProgressBar: React.FC = () => {
  const pending = useSyncExternalStore(
    subscribeNavProgress,
    isNavPending,
    () => false,
  );

  if (!pending) return null;

  return (
    <div className="route-progress" role="progressbar" aria-busy="true" aria-label="Loading page">
      <div className="route-progress__bar" />
    </div>
  );
};

export default RouteProgressBar;
